import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textShow",
  "use": "icon-textShow-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textShow\">\r\n<path d=\"M11.5097 18.3157H14.036V8.2104H19.0886V5.68408H6.45703V8.2104H11.5097V18.3157Z\" fill=\"currentColor\" />\r\n<rect x=\"1.27344\" y=\"0.5\" width=\"23\" height=\"23\" stroke=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol